module.exports = __webpack_public_path__ + "static/img/013.f221493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/013.png
// module id = dRUP
// module chunks = 1